import {
  Button as ButtonAntd,
  Card as CardAntd,
  Col as ColAntd,
  Typography as TypographyAntd,
} from 'antd';
import styled from 'styled-components';

export const Card = styled(CardAntd)`
  height: 100%;
  width: 100%;

  .ant-card-body {
    padding: 12px;
  }
`;

export const Status = styled.div`
  div {
    border: 1px solid #ffffff;
    box-sizing: border-box;
    border-radius: 20px;
    display: inline-block;
    color: #ffffff;
    font-size: 12px;
    padding: 2px 10px;
    margin-left: 10px;
  }

  .Carregando {
    background-color: #24a95d !important;
  }
  .Suspenso {
    background-color: #e47515 !important;
  }
  .Encerrado {
    background-color: #9b51e0 !important;
  }
  .Finalizado {
    background-color: #d42929 !important;
  }
`;

export const ItemPopover = styled.div`
  color: #ffffff;
`;

export const Item = styled(ColAntd)`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Button = styled(ButtonAntd)`
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  border: 1px solid ${props => props.color};
  border-radius: 4px !important;
  box-sizing: border-box;
  margin-right: 8px;
  background: ${props => props.color};
  color: #fff;

  :hover {
    color: ${props => props.color};
    border: 1px solid ${props => props.color};
  }
`;

export const Title = styled(TypographyAntd.Title)`
  color: #676a6c;
  font-size: 14px !important;
  font-weight: bold !important;
  color: ${props => props.color} !important;
`;

export const SubTitle = styled(TypographyAntd.Paragraph)`
  word-break: break-word;
  color: #676a6c;
  margin-bottom: 0px !important;
  font-size: 14px !important;
  font-weight: normal !important;
`;

export const Text = styled(TypographyAntd.Paragraph)`
  color: #676a6c;
  font-size: 14px !important;
  font-weight: normal !important;
  text-align: center;
`;
